<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <main id="main-container">
      <div class="bg-body-light border-top border-bottom">
        <div class="content content-full py-1">
          <div class="block block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">Account <small>Detail</small></h3>
              <div
                class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center"
              ></div>
            </div>
          </div>
        </div>
        <div class="alert alert-danger mb-0" role="alert" v-show="error">
          <div class="container" v-html="error" id="editErrorMessage">
            <!-- {{ error }} -->
          </div>
        </div>

        <div class="content">
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-form-label">User Name : </label>
              <label class="col-form-label" style="margin-left:5px">{{
                user.name
              }}</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-form-label">Email :</label>
              <label class="col-form-label" style="margin-left:5px">{{
                user.email
              }}</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-form-label">Created At :</label>
              <label class="col-form-label" style="margin-left:5px">{{
                user.created_at
              }}</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="col-form-label">Updated At :</label>
              <label class="col-form-label" style="margin-left:5px">{{
                user.updated_at
              }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <button
                class="btn btn-outline-warning btn-lg btn-block"
                @click="$router.push('/')"
              >
                Dashboard
              </button>
            </div>
            <div class="col-4">
              <button
                class="btn btn-outline-success btn-lg btn-block"
                @click="$router.push(`/user/${user.id}`)"
              >
                Edit
              </button>
            </div>
            <!--<div class="col-4">
            <button
              class="btn btn-outline-info btn-lg btn-block"
              @click="$router.push('/')"
            >
              Cancel
            </button>
          </div>-->
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </main>
    <nav
      class="navbar navbar-light p-4 mt-4 w-100"
      style=" background-color: #ffa400 !important;font-size:16px; bottom:0px; position:absolute"
    >
      <div class="container">
        <a href="/" class="navbar-brand text-dual"
          ><span class="font-w300 text-white">Copyright© 2020</span>
          <span class="font-w300 text-white">ARX</span></a
        >
      </div>
    </nav>
  </div>
</template>
<script>
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import safeLocalStorage from "../utils/localstorage";
// import UsersList from "../components/UsersList";
export default {
  name: "Account",
  components: {
    SidebarComponent,
    HeaderComponent
    // UsersList,
  },
  data: function() {
    return {
      user: JSON.parse(safeLocalStorage.getItem("user"))
    };
  },
  mounted() {
    if (safeLocalStorage.getItem("user")) {
      try {
        this.username = JSON.parse(safeLocalStorage.getItem("user")).name;
      } catch (e) {
        this.username = "User";
      }
    }
  }
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
</style>
